import { qualifySelector } from "../utils";

import {
  GET_PRODUCTS_REQUEST,
  GET_PRODUCTS_SUCCESS,
  GET_PRODUCTS_FAILURE,
  GET_PRODUCTS_LOADED,
  SELECT_NEW_PACKAGE,
} from "../constants";

// Models
import hostingPackage from "../models/hostingPackage";
import addonProduct from "../models/addonProduct";

// Texts, icons
import getProductName from "../../components/UpsellSection/utils/getProductName.js";
import getProductIcon from "../../components/UpsellSection/utils/getProductIcon.js";
import getProductFeatures from "../../components/UpsellSection/utils/getProductFeatures.js";

const initialState = {
  productsLoading: false,
  packages: [],
  addonProducts: [],
  upsellProducts: [],
};

function reducer(state = initialState, action) {
  const { payload } = action;

  switch (action.type) {
    case GET_PRODUCTS_REQUEST:
      return {
        ...state,
        productsLoading: true,
      };

    case GET_PRODUCTS_SUCCESS:
      const { packageCaps } = payload;

      return {
        ...state,
        productsLoading: false,
        packages: payload.packages.sizes.map((size) => {
          const caps = packageCaps[size.name];

          return hostingPackage(
            size,
            getProductName(size.name),
            getProductFeatures(size.name, caps),
            getProductIcon(size.name),
          );
        }),
        addonProducts: payload.addonProducts.map((product) => {
          return addonProduct(
            product,
            getProductFeatures(product),
            getProductName(product),
            getProductIcon(product),
            payload.addonProductPrices[product],
          );
        }),
        highlightedUpsellProductId: payload.highlightedUpsell,
        upsellProducts:
          payload.upsellProducts.length > 0
            ? payload.upsellProducts
            : [...state.upsellProducts],
      };

    case GET_PRODUCTS_FAILURE:
      return {
        ...state,
        productsLoading: false,
        packages: [],
        upsellProducts: [],
      };

    case SELECT_NEW_PACKAGE:
      // Set prices on addon products in store
      if (payload.addonProductPrices) {
        for (const entry of state.addonProducts) {
          if (payload.addonProductPrices[entry.id]) {
            entry.productPrice = payload.addonProductPrices[entry.id];
          }
        }
      }

      return {
        ...state,
        productsLoading: false,
        upsellProducts:
          payload.upsellProducts.length > 0
            ? payload.upsellProducts
            : [...state.upsellProducts],
        addonProducts: state.addonProducts,
      };

    case GET_PRODUCTS_LOADED:
      return {
        ...state,
        productsLoading: false,
      };

    default:
      return {
        ...state,
      };
  }
}

export const name = "products";
export default { [name]: reducer };

export const hostingProductsLoading = qualifySelector(
  name,
  (state) => state.productsLoading,
);

export const getHostingPackages = qualifySelector(
  name,
  (state) => state.packages,
);

export const getUpsellProducts = qualifySelector(
  name,
  (state) => state.upsellProducts,
);

export const getAddonProducts = qualifySelector(
  name,
  (state) => state.addonProducts,
);

export const getHighlightedUpsellProductId = qualifySelector(
  name,
  (state) => state.highlightedUpsellProductId,
);

function getSortedUpsellAddons(upsellProductIds, addonProducts) {
  return addonProducts
    .filter(({ id }) => upsellProductIds.includes(id))
    .sort((a, b) => {
      const indexA = upsellProductIds.indexOf(a.id);
      const indexB = upsellProductIds.indexOf(b.id);
      return indexA - indexB;
    });
}

export const getShouldOfferDomainProtection = qualifySelector(name, (state) => {
  const upsellAddons = getSortedUpsellAddons(
    state.upsellProducts,
    state.addonProducts,
  );

  return (
    !state.productsLoading &&
    upsellAddons.some((upsell) => upsell.id === "DNS_ADMIN")
  );
});

export const getDomainProtectionUpsell = qualifySelector(name, (state) => {
  const upsellAddons = getSortedUpsellAddons(
    state.upsellProducts,
    state.addonProducts,
  );

  if (state.productsLoading) {
    return null;
  }

  return upsellAddons.find((upsell) => upsell.id === "DNS_ADMIN") || null;
});
